import { X, Save } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useGlobalStates } from "./globalConstants";

export default function SessionEditor() {
    const { difficultyLevel, socket, scenario, setScenario, setDisplayEditor } = useGlobalStates();
    const [inputMessage, setInputMessage] = useState("");

    useEffect(() => {
        const levels = scenario?.scenario || scenario; // handle nested or flat
        const value = levels?.[difficultyLevel.toLowerCase()] ?? "";
        setInputMessage(value);
        console.log("CURRENT SCENARIO:", value);
    }, [difficultyLevel, scenario]);


    const changeScenario = () => {
        setDisplayEditor(false);
        if (!inputMessage.trim()) return;

        setScenario(prev => {
            const levels = prev?.scenario || prev;
            return prev?.scenario
                ? { ...prev, scenario: { ...levels, [difficultyLevel.toLowerCase()]: inputMessage } }
                : { ...levels, [difficultyLevel.toLowerCase()]: inputMessage };
        });

        socket.emit("change_scenario", {
            new_scenario: inputMessage,
        });
    };

    return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={() => setDisplayEditor(false)}  
        >
            <div
              className="bg-white rounded-xl shadow-sm border border-gray-200 w-[45vw] max-h-[88vh]"
              onClick={e => e.stopPropagation()}  
            >
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Edit {difficultyLevel} Scenario
                    </h2>
                    <button
                      onClick={() => setDisplayEditor(false)}
                      className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                      <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="flex-1 p-6">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                        Scenario Description
                        </label>
                        <p className="text-sm text-gray-600 mb-4">
                        Define the background story and context for this difficulty level. This will influence how the agents behave and respond to therapeutic interventions.
                        </p>
                        <textarea
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)} 
                        className="w-full h-48 p-4 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        placeholder={`Enter the scenario description for ${difficultyLevel} difficulty level...`}
                        />
                        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Tips for writing scenarios:</h4>
                        <ul className="text-xs text-gray-600 space-y-1">
                            <li>• <strong>Easy:</strong> Couples with minor issues, willing to work together</li>
                            <li>• <strong>Medium:</strong> Typical relationship challenges with some resistance</li>
                            <li>• <strong>Hard:</strong> Severe distress, highly defensive, resistant to change</li>
                        </ul>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
                    <button
                    onClick={() => {
                        setDisplayEditor(false);
                    }}
                    className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                    Cancel
                    </button>
                    <button
                    onClick={changeScenario}
                    disabled={inputMessage === scenario[difficultyLevel.toLowerCase()]}
                    className="flex items-center space-x-2 px-4 py-2 text-sm font-medium bg-green-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                    <Save className="h-4 w-4" />
                    <span>Save Scenario</span>
                    </button>
                </div>
            </div>
        </div>
    )
}